/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';

import styles from './styles.module.scss';
import Tooltip from '../Tooltip';
import titleImg from '../../assets/images/title.svg';
import peopleImg from '../../assets/images/people.svg';
import tagsImg from '../../assets/images/tags.svg';
import actions from '../../redux/actions';
import { getCategories } from '../../redux/reducers/categories';
import { prettifyArray } from '../../utils/string';

import type {
  Category,
  Fetchable,
  ReduxState,
  SortingParams,
  TrackSearchFullParams,
  TrackSortingField,
  Translate,
} from '../../types';

type Props = TrackSearchFullParams & {
  categories: Fetchable<Category[]>,
  categoryIds?: number[],
  total?: number,
  t: Translate,
};

const mapStateToProps = (state: ReduxState) => {
  return {
    categories: getCategories(state),
  };
};

class TrackSearchQuery extends React.PureComponent<Props, void> {
  _fieldName = (sorting: SortingParams<TrackSortingField>, t: Translate): string => {
    switch (sorting.field) {
      case 'title':
        return t('TITLE');
      case 'media':
        return t('SUPPORT_TITLE');
      case 'authors':
        return t('AUTHORS');
      case 'performers':
        return t('PERFORMERS');
      default:
        return sorting.field;
    }
  };
  _translateField = (sorting?: SortingParams<TrackSortingField>) => {
    const { t } = this.props;
    if (sorting) {
      return `${this._fieldName(sorting, t)} (${sorting.order === 'asc' ? 'A…Z' : 'Z…A'})`;
    } else {
      return this.props.t('RELEVANCE');
    }
  };
  _getFlagsLabel = () => {
    const title = !!_.get(this.props, 'flags.title');
    const people = !!_.get(this.props, 'flags.people');
    const tags = !!_.get(this.props, 'flags.tags');
    const isAllActive = (title && people && tags) || (!title && !people && !tags);
    const { t } = this.props;
    return (
      <React.Fragment>
        {(title || isAllActive) && (
          <Tooltip title={t('TITLE')}>
            <img style={{ width: '1em', marginRight: '0.5em' }} src={titleImg} alt={t('TITLE')} />
          </Tooltip>
        )}
        {(tags || isAllActive) && (
          <Tooltip title={t('TAGS')}>
            <img style={{ width: '1em', marginRight: '0.5em' }} src={tagsImg} alt={t('TAGS')} />
          </Tooltip>
        )}
        {(people || isAllActive) && (
          <Tooltip title={t('PEOPLE')}>
            <img style={{ width: '1em', marginRight: '0.5em' }} src={peopleImg} alt={t('PEOPLE')} />
          </Tooltip>
        )}
      </React.Fragment>
    );
  };

  render() {
    const { text, total = 0, categories, categoryIds, sorting, t } = this.props;
    const categoryNames = (categoryIds || []).map(
      id => ((categories.data || []).find(category => category.id === id) || {}).description
    );
    return (
      <div className={styles.container}>
        <div className={styles.def}>
          <div className={styles.highlighted}>
            {t('YOU_SEARCHED_QUERY', {
              resultsCount: total,
              resultsType: total > 1 ? t('TRACKS') : t('TRACK'),
              searchString: text,
              categories:
                categoryNames.length > 0 ? prettifyArray(categoryNames) : t('ALL_CATEGORIES'),
              ordering: this._translateField(sorting),
            })}{' '}
            {this._getFlagsLabel()}
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(connect(mapStateToProps, actions)(TrackSearchQuery));
